import { Button } from '@/components/customer-ui/button'
import { Calendar } from '@/components/ui/calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from '@/components/ui/popover'
import { cn } from '@/lib/utils'
import { format } from 'date-fns'
import { nlBE } from 'date-fns/locale'
import { CalendarIcon } from 'lucide-react'

export const DatePicker = ({
  value,
  onChange
}: {
  value?: Date
  onChange: (date: Date | undefined) => void
}) => {
  // const now = new Date()
  // const todayStart = startOfDay(now)
  // const todayEnd = endOfDay(now)

  // const start = startOfQuarter(now)
  // const end = endOfQuarter(now)

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant='outline'
          className={cn(
            'w-full justify-start text-left font-normal',
            !value && 'text-muted-foreground'
          )}
        >
          <CalendarIcon className='mr-2 h-4 w-4' />
          {value ? (
            <span>{format(value, 'dd-MM-yyyy')}</span>
          ) : (
            <span>Selecteer datum</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className='border-input w-auto overflow-hidden p-0'
        align='start'
      >
        <Calendar
          mode='single'
          selected={value}
          onSelect={onChange}
          autoFocus
          locale={nlBE}
          // disabled={(date) => {
          //   return date < start || date > end || date > todayEnd
          // }}
          className={cn('pointer-events-auto p-3')}
        />
      </PopoverContent>
    </Popover>
  )
}
